import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormState } from '@shared';

@Component({
  selector: 'app-pro-account-ids-form',
  templateUrl: './pro-account-ids-form.component.html',
  styleUrls: ['./pro-account-ids-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProAccountIdsFormComponent implements OnInit {
  @Input() state: FormState;
  @Output() saveNewProLink = new EventEmitter();
  form: FormGroup;
  formStates = FormState;
  formInvalidMessage: string;

  constructor(private fb: FormBuilder) {}

  ngOnInit() {
    this.form = this.fb.group({
      proAccountId: this.fb.control(null, [
        Validators.required,
        Validators.pattern(/^[0-9]*$/i),
        Validators.max(9999999999),
      ]),
    });
  }

  get proAccountId() {
    return this.form.get('proAccountId') as FormControl;
  }

  get showFormInvalidMessage() {
    return this.proAccountId.dirty && this.form.status !== 'VALID';
  }

  onSubmit(event) {
    event.preventDefault();
    if (this.form.valid) {
      this.saveNewProLink.emit(this.proAccountId.value as number);
    }
  }
}
